import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询商家样衣管理列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/getProductList`, params),
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/deleteProduct`, params),
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/updateProduct`, params),
}